/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaColumnasVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaColumnas: React.FunctionComponent<ITablaColumnasVistaProps & InjectedIntlProps> = ({
    columnass,
    cargarColumnas,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={columnass}
            actions={acciones(manejarFormulario, cargarColumnas, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaColumnas);
